module.exports = __webpack_public_path__ + "static/img/logo.4c7d6ff3.png";